import { Pipe, PipeTransform } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Pipe({
	name: "tooltipSelectComponents",
	pure: true, // Aggiunto per migliorare le prestazioni
})
export class TooltipSelectComponentsPipe implements PipeTransform
{
	constructor(private translate: TranslateService)
	{
	}

	transform(
		values: any[],
		idField: string,
		descriptionField: string,
		currentSelectId: any,
		defaultValue: any,
		useTranslation: boolean = false,
		translationPrefix: string = "",
	): string | null
	{
		// Null input or void
		if (!values || values.length === 0 || !currentSelectId)
		{
			// return defaultValue[descriptionField] || null;
			if ( defaultValue )
				return defaultValue[descriptionField];
			else 
				return null;
		}

		// Use translation...
		if (useTranslation && translationPrefix)
		{
			if (Array.isArray(currentSelectId))
			{ 
				//Multiselect
				let tooltip: string[] = [];

				for (let value of currentSelectId)
				{
					const translationKey = `${translationPrefix}_${String(value).toUpperCase()}`;
					const translatedValue = this.translate.instant(translationKey);

					if (translatedValue !== translationKey)
					{ 
						//If exists...
						tooltip.push(translatedValue);
					} 
					else
					{
						tooltip.push(this.getDescriptionsOfSelected(values, idField, descriptionField, value, value) ?? "");
					}
				}

				return tooltip.length > 0
					? tooltip.join(", ")
					: defaultValue[descriptionField] || null;

			}

			const translationKey = `${translationPrefix}_${String(currentSelectId).toUpperCase()}`;
			const translatedValue = this.translate.instant(translationKey);

			if (translatedValue !== translationKey)
			{ 
				//If exists...
				return translatedValue;
			}
		}

		// Gestione selezione singola o multipla
		return this.getDescriptionsOfSelected(
			values,
			idField,
			descriptionField,
			currentSelectId,
			defaultValue,
		);
	}

	private getDescriptionsOfSelected(
		values: any[],
		idField: string,
		descriptionField: string,
		currentSelectId: any,
		defaultValue: string = "",
	): string | null
	{
		// Multiselect
		if (Array.isArray(currentSelectId))
		{
			const selectedRecords = values.filter(record =>
				currentSelectId.includes(record[idField]),
			);

			return selectedRecords.length > 0
				? selectedRecords.map(record => record[descriptionField]).join(", ")
				: defaultValue || null;
		}

		//Single select
		const selectedValue = values.find(elem => elem[idField] == currentSelectId);

		return selectedValue
			? selectedValue[descriptionField]
			: defaultValue || null;
	}
}